import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { ClientSessionService } from 'src/core/services/client-session/client-session.service';
import { TenantContextService } from 'src/core/services/tenant-context/tenant-context.service';

export const clientSessionGuard: CanActivateFn = () => {
  const session = inject(ClientSessionService);
  const tenant = inject(TenantContextService);

  if (session.current) return true;

  tenant.goToLogin();
  return false;
};
